import React from 'react'
import ProjectComponent from '../../Components/ProjectPage/Project.component'
import BackgroundImage from "../../assets/images/BackgroundImage.jpg"

const Project = () => {
	return (
		<ProjectComponent 
			bgColor={BackgroundImage} 
			heading="PROJECTS"
		/>
	)
}

export default Project
